module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-600.e63b93dfac2600782654.ttf";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-600.ttf
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-600.ttf
// module chunks = styles